<template>
  <div>
    <Upload accept="image/*" action="#" :before-upload="beforeUpload">
      <slot/>
    </Upload>

    <Modal v-model="showCropper" :closable="false" @on-ok="cropperOk">
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :fixed="option.fixed"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :fixedBox="option.fixedBox"
          ></vueCropper>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import common from "@/common/common";

export default {
  name: "MtCropper",
  data: () => ({
    showCropper: false,
    token: "",
    option: {
      img: "",
      info: true,
      outputSize: 1,
      outputType: "png",
      canScale: false,
      autoCrop: true,
      fixed: true,
      full: true,
      canMoveBox: true,
      original: false,
      centerBox: false,
      infoTrue: true
    }

  }),

  created() {
    this.token = common.getToken();
  },
  methods: {
    beforeUpload(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.option.img = reader.result;
        this.showCropper = true;
      };
      return false;
    },
    //将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      if (!filename) {
        //若无文件名则取当前时间戳
        filename = Date.parse(new Date()) + ".jpg";
      }
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    cropperOk() {
      const hide = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      this.$refs.cropper.getCropData((data) => {
        let blob = this.dataURLtoFile(data);
        let formData = new FormData();
        formData.append("file", blob);
        formData.append("token", this.token);
        this.axios.post(this.config.urlArray.commonUploadImage, formData,{ headers: { "Content-Type": "multipart/form-data" } }).then((res) => {
          this.showCropper = false;
          // let url = "https://bank-mp.balingmedia.com" + res.data.data
          let url = "https://bank-mp.mtdevelop.cn" + res.data.data

          this.$emit("uploadCoverImg", url);
          this.$emit("change", url);
          hide();
        }).catch(()=>{
          hide();
        });
      });
    },
  }
}
</script>

<style lang="scss">
.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}

.mt-cropper-uploader {
  display: block;

  .ant-upload {
    display: block !important;
  }
}
</style>
